import React from "react";
import { DatePicker } from "antd";
import Text from "../typography/text";
import RequiredIcon from "../../icons/required-icon";
import { colors } from "../../theme/colors";

const DatePickerComponent = ({
  titleText,
  value,
  setValue,
  isRequired,
  isDisabled,
  onChange,
  // placeholder = "Select date",
  helperText,
  // errorText,
  format,
  picker,
  disabledDate,
  parentClassName,
}) => {
  const handleChange = (date) => {
    setValue(date);
  };

  return (
    <>
      <div className={`text-input-container ${parentClassName}`}>
        <div className={isRequired ? "text-input-title" : ""}>
          <Text variant="tinyText">{titleText}</Text>
          {isRequired && <RequiredIcon />}
        </div>

        <DatePicker
          //   ref={datePickerRef}
          picker={picker}
          onChange={onChange ?? handleChange}
          value={value}
          //   format={"MMMM D, YYYY"}
          format={format}
          disabled={isDisabled}
          disabledDate={disabledDate}
          style={{
            width: parentClassName === "full-width-button" ? "100%" : "240px",
            minHeight: "36px",
            borderRadius: "3px",
            borderColor: colors["strokeDark"],
          }}
        />
        {helperText && (
          <Text variant="tinyText" color="lightText">
            {helperText}
          </Text>
        )}
      </div>
    </>
  );
};

export default DatePickerComponent;
